import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFlintDialogContext } from "@components/page_components/common/dialogs/FlintDialogContextProvider";

export interface SapCodeBadgeProps {
    value: string | null | undefined;
    isReadOnly: boolean;
    onSave: (value: string) => void;
    onRemove: () => void;
}

export function useSapCodeBadge(props: SapCodeBadgeProps) {
    const { t } = useTranslation();
    const { showAreYouSureDialog } = useFlintDialogContext();
    const [isSapEditOpen, setIsSapEditOpen] = useState(false);

    const addLabel = t("SAP_CODE_AddLink");

    function handleConfirmRemove() {
        showAreYouSureDialog({ onAccept: props.onRemove });
    }

    return {
        state: { isSapEditOpen },
        handlers: {
            openSapEdit: () => setIsSapEditOpen(true),
            closeSapEdit: () => setIsSapEditOpen(false),
            handleConfirmRemove,
        },
        utilities: { addLabel },
    };
}
